module.exports = __webpack_public_path__ + "img/w3_circle_trash_black.ffe11c28.png";